<template>
  <div>
    <a-modal v-model="visible" :title="`Edit timetable entry for ${day}`" style="top: 20px;" @cancel="handleCancel" :destroyOnClose="true">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Update</a-button>
      </template>
      <a-spin :spinning="loading">
        <a-form :form="form" @submit="handleSubmit">
          <div class="row mb-0">
            <!-- Start time -->
            <div class="col-md-4 mb-2">
              <a-form-item
                label="Start Time"
              >
                <a-time-picker
                :open="open"
                @openChange="handleTimePickerOpenChange"
                v-decorator="[
                  'start_time',
                  {rules: [{ required: true, message: 'Please input an start time' }], initialValue: moment()},
                  ]"
                  use12Hours :format="timeFormat"
                >
                  <a-button slot="addon" size="small" type="primary" @click="handleTimePickerClose">Ok</a-button>
                </a-time-picker>
              </a-form-item>
            </div>
            <!-- End time -->
            <div class="col-md-4 mb-2">
              <a-form-item
                label="End Time"
              >
                <a-time-picker
                :open.sync="open2"
                v-decorator="[
                  'end_time',
                  {rules: [{ required: true, message: 'Please input an end time' }], initialValue: moment()},
                  ]"
                  use12Hours :format="timeFormat"
                >
                  <a-button slot="addon" size="small" type="primary" @click="handleTimePickerClose">Ok</a-button>
                </a-time-picker>
              </a-form-item>
            </div>
            <!-- Select Type -->
            <div class="col-md-4 mb-2">
              <a-form-item
                label="Type"
              >
                <a-select
                  width="100%"
                  v-decorator="[
                    'type',
                    {rules: [{ required: true, message: 'Please select a value!!' }],  initialValue: 0 },
                  ]"
                  @change="generatedValue"
                >
                  <a-select-option :value="0">
                    Normal
                  </a-select-option>
                  <a-select-option :value="1">
                    Break
                  </a-select-option>
                  <a-select-option :value="2">
                    Off
                  </a-select-option>
                  <a-select-option :value="3">
                    Assembly
                  </a-select-option>
                  <a-select-option :value="9">
                    Custom
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>

            <div class="col-12 mb-2">
              <a-form-item
                label="Type Value"
                :hidden="!form.getFieldValue('type')"
              >
                <a-input
                  placeholder="Type Value"
                  v-decorator="['type_value']"
                  :hidden="!form.getFieldValue('type')"
                />
              </a-form-item>
            </div>
            <div class="col-12 mb-2" v-if="!form.getFieldValue('type')">
              <p class="mb-0 py-2">
                <a-checkbox :checked="isMultiSubject" @change="onMultiSubjectChange">
                  Select multiple subjects other than Electives or Subject Groups
                </a-checkbox>
              </p>
            </div>

            <template v-if="!isMultiSubject && !form.getFieldValue('type')">
              <!-- Select Subject -->
              <div class="col-md-6 mb-2" v-if="!form.getFieldValue('type')">
                <a-form-item
                  label="Subject"
                >
                  <a-select
                    placeholder="Select Subject"
                    width="100%"
                    v-decorator="[
                      'subject_id',
                      {rules: [{ required: true, message: 'Please select a subject!!' }], initialValue: undefined },
                    ]"
                    :loading="subjectSelectSpinning"
                    @change="handleSubjectSelect"
                  >
                    <a-select-option :value="undefined">
                      Select Subject
                    </a-select-option>
                    <a-select-option
                      v-for="subject in classSubjects.all"
                      :value="subject.subject.id"
                      :key="subject.id"
                    >
                      {{subject.subject.name}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <!-- Select Teacher -->
              <div class="col-md-6 mb-2"  v-if="!checkGroupOrElective() && form.getFieldValue('type') === 0">
                <a-form-item
                  label="Teacher"
                >
                  <a-select
                    placeholder="Select Teacher"
                    width="100%"
                    v-decorator="[
                      'teacher_id',
                      {rules: [{ required: true, message: 'Please select a teacher!!' }],  initialValue: undefined },
                    ]"
                    :loading="teacherSelectSpinning"
                    :disabled="true"
                  >
                    <a-select-option :value="undefined">
                      Select Teacher
                    </a-select-option>
                    <a-select-option
                      v-for="teacher in teachers"
                      :value="teacher.id"
                      :key="teacher.id"
                    >
                      {{teacher.first_name}} {{teacher.last_name}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>

              <!-- If electives -->
              <div class="col-md-12 mb-2" v-if="electiveSubjects.length">
                <p class="font-weight-bold text-dark mb-0">Electives:</p>
                <table class="table table-sm table-borderless mb-0">
                  <tbody>
                    <tr v-for="electiveSubject in electiveSubjects" :key="electiveSubject.subject_id">
                      <th scope="row" style="vertical-align:middle;width: 50%;">
                        {{ electiveSubject.subject_name }} ({{ electiveSubject.abbreviation }})
                        <a-form-item class="d-none">
                          <a-input
                            placeholder="Select Teacher"
                            width="100%"
                            v-decorator="[
                              `subject_teachers[${electiveSubject.subject_id}]subject_id`,
                              {rules: [{ required: true, message: 'Please select a subject!!' }],  initialValue: electiveSubject.subject_id },
                            ]"
                          >
                          </a-input>
                        </a-form-item>
                      </th>
                      <td scope="col" style="width: 50%;" class="p-0">
                        <a-form-item>
                          <a-select
                            placeholder="Select Teacher"
                            width="100%"
                            v-decorator="[
                              `subject_teachers[${electiveSubject.subject_id}]teacher_id`,
                              {rules: [{ required: true, message: 'Please select a teacher!!' }],  initialValue: undefined },
                            ]"
                            :loading="teacherSelectSpinning"
                          >
                            <a-select-option :value="undefined">
                              Select Teacher
                            </a-select-option>
                            <a-select-option
                              v-for="teacher in teachers"
                              :value="teacher.id"
                              :key="teacher.id"
                            >
                              {{teacher.first_name}} {{teacher.last_name}}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- If group -->
              <div class="col-md-12 mb-2" v-if="groupSubjects.length">
                <p class="font-weight-bold text-dark mb-0">Group SUbjects:</p>
                <table class="table table-sm table-borderless mb-0">
                  <tbody>
                    <tr v-for="groupSubject in groupSubjects" :key="groupSubject.subject_id">
                      <th scope="row" style="vertical-align:middle;width: 50%;">
                        {{ groupSubject.subject_name }} ({{ groupSubject.abbreviation }})
                        <a-form-item class="d-none">
                          <a-input
                            placeholder="Select Teacher"
                            width="100%"
                            v-decorator="[
                              `subject_teachers[${groupSubject.subject_id}]subject_id`,
                              {rules: [{ required: true, message: 'Please select a subject!!' }],  initialValue: groupSubject.subject_id },
                            ]"
                          >
                          </a-input>
                        </a-form-item>
                      </th>
                      <td scope="col" style="width: 50%;" class="p-0">
                        <a-form-item>
                          <a-select
                            placeholder="Select Teacher"
                            width="100%"
                            v-decorator="[
                              `subject_teachers[${groupSubject.subject_id}]teacher_id`,
                              {rules: [{ required: true, message: 'Please select a teacher!!' }],  initialValue: undefined },
                            ]"
                            :loading="teacherSelectSpinning"
                          >
                            <a-select-option :value="undefined">
                              Select Teacher
                            </a-select-option>
                            <a-select-option
                              v-for="teacher in teachers"
                              :value="teacher.id"
                              :key="teacher.id"
                            >
                              {{teacher.first_name}} {{teacher.last_name}}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
            <template v-if="isMultiSubject && !form.getFieldValue('type')">
              <!-- If multi subject -->
              <div class="col-md-12">
                <p class="font-weight-bold text-dark mb-0">Multi Subjects:</p>
                <table class="table table-sm table-borderless mb-0">
                  <tbody>
                    <tr v-for="count in multiSubjectCount" :key="count">
                      <th style="vertical-align:middle;width: 50%;" class="p-0 pr-md-2">
                        <a-form-item>
                          <a-select
                            placeholder="Select Subject"
                            width="100%"
                            v-decorator="[
                              `subject_teachers[${count-1}]subject_id`,
                              {rules: [{ required: true, message: 'Please select a subject!!' }],  initialValue: undefined },
                            ]"
                            :loading="subjectSelectSpinning"
                            @change="handleSubjectSelect($event,count)"
                          >
                            <a-select-option :value="undefined">
                              Select Subject
                            </a-select-option>
                            <a-select-option
                              v-for="subject in classSubjects.all"
                              :value="subject.subject.id"
                              :key="subject.id"
                            >
                              {{subject.subject.name}}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </th>
                      <td style="vertical-align:middle;width: 50%;" class="p-0">
                        <a-form-item>
                          <a-select
                            placeholder="Select Teacher"
                            width="100%"
                            v-decorator="[
                              `subject_teachers[${count-1}]teacher_id`,
                              {rules: [{ required: true, message: 'Please select a teacher!!' }],  initialValue: undefined },
                            ]"
                            :loading="teacherSelectSpinning"
                            :disabled="true"
                          >
                            <a-select-option :value="undefined">
                              Select Teacher
                            </a-select-option>
                            <a-select-option
                              v-for="teacher in teachers"
                              :value="teacher.id"
                              :key="teacher.id"
                            >
                              {{teacher.first_name}} {{teacher.last_name}}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="pt-4">
                  <a href="javascript:;" class="btn btn-sm btn-dark btn-with-addon mr-2"
                    @click="handleAddMoreSubject"
                    v-if="multiSubjectCount < 6"
                  >
                    <span class="btn-addon">
                      <i class="btn-addon-icon fe fe-plus" />
                    </span>
                    Subject
                  </a>
                  <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon mr-2"
                    @click="handleRemoveSubject"
                    v-if="multiSubjectCount > 2"
                  >
                    <span class="btn-addon">
                      <i class="btn-addon-icon fe fe-minus" />
                    </span>
                    Subject
                  </a>
                </div>
              </div>
            </template>

          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapValues } from 'lodash'

import { makeTimetableFields, makeTimetableGroupFields, makeTimetableGroupSubjectsFields, makeTimetableMultiFields, makeTimetableMultiSubjectsFields } from './fields'

export default {
  name: 'AddTimetableEntry',
  mounted: function() {
    this.$eventBus.$on('openTimetableEditEntryModal', this.showModal)
  },

  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      classId: undefined,
      sectionId: undefined,
      sessionId: undefined,
      timeFormat: 'h:mm a',
      position: undefined,
      day: undefined,
      open: false,
      open2: false,
      multiSubjectCount: 2,
      isMultiSubject: false,
      classSubjects: [],
      electiveGroupSubjectIds: [],
      electiveSubjects: [],
      groupSubjectIds: [],
      groupSubjects: [],
      teachers: [],
      timetableData: {},
      subjectSelectSpinning: false,
      teacherSelectSpinning: false,
      typeValue: null,
      periodType: null,
    }
  },
  methods: {
    moment,
    generatedValue(value) {
      switch (value) {
        case 0: // Normal
          this.typeValue = null
          break
        case 1: // Break
          // return 'Break'
          this.typeValue = 'Break'
          break
        case 2: // Off
          // return 'Off'
          this.typeValue = 'Off'
          break
        case 3: // Assembly
          // return 'Assembly'
          this.typeValue = 'Assembly'
          break
        case 9: // Assembly
          // return 'Custom'
          this.typeValue = 'Custom'
          break
        default:
          this.typeValue = null
      }

      if (this.periodType === value) {
        this.getClassSubjects()
      }
      this.form.setFieldsValue({
        type_value: this.typeValue,
      })
    },
    showModal(data) {
      this.visible = true
      this.timetableData = data
      this.classId = data.class_id
      this.sectionId = data.section_id
      this.sessionId = data.session_id
      this.position = data.position
      this.day = data.day
      this.periodType = data.type

      if (data.group_type === 1) {
        this.electiveSubjects = data.group_subject_entries.map(element => {
          element.subject.subject_name = element.subject.name
          element.subject.subject_id = element.subject.id
          return element.subject
        })
      }

      if (data.group_type === 2) {
        this.groupSubjects = data.group_subject_entries.map(element => {
          element.subject.subject_name = element.subject.name
          element.subject.subject_id = element.subject.id
          return element.subject
        })
      }

      if (data.group_type === 3) {
        this.isMultiSubject = true
        this.multiSubjectCount = data.group_subject_entries.length
      }

      this.getClassSubjects()
    },
    getClassSubjects() {
      this.loading = true
      this.subjectSelectSpinning = true
      this.teacherSelectSpinning = true
      this.$http.get(`/api/subject/class/${this.classId}`, {
        params: {
          session_id: this.sessionId,
        },
      })
        .then(({ data }) => {
          this.subjectSelectSpinning = false
          this.classSubjects = data.data
          this.electiveGroupSubjectIds = data.data.elective_subjects.map(elective => {
            return elective.elective_subject_id
          })
          this.groupSubjectIds = data.data.group_subjects.map(group => {
            return group.group_subject_id
          })

          this.getTeachers()
        })
        .catch(error => {
          this.subjectSelectSpinning = false
          console.log(error)
        })
    },
    getTeachers() {
      this.teacherSelectSpinning = true
      this.$http.get(`/api/teacher`, {
        params: {
          limit: 100,
        },
      })
        .then(({ data }) => {
          this.teacherSelectSpinning = false
          this.teachers = data.data

          let fieldsData
          let groupSubjectsFields
          if (this.timetableData.group_type === 0) {
            fieldsData = makeTimetableFields(this.timetableData)
          } else if (this.timetableData.group_type === 1 || this.timetableData.group_type === 2) {
            fieldsData = makeTimetableGroupFields(this.timetableData)
            groupSubjectsFields = makeTimetableGroupSubjectsFields(this.timetableData)
          } else {
            fieldsData = makeTimetableMultiFields(this.timetableData)
            groupSubjectsFields = makeTimetableMultiSubjectsFields(this.timetableData)
          }
          this.$nextTick(() => {
            this.form.setFieldsValue({
              ...fieldsData,
              ...groupSubjectsFields,
            })
          })
          this.loading = false
        })
        .catch(error => {
          this.teacherSelectSpinning = false
          this.loading = false
          console.log(error)
        })
    },
    handleTimePickerOpenChange(open) {
      this.open = open
    },
    handleTimePickerClose() {
      this.open = false
      this.open2 = false
    },
    /* handleSubjectSelect(value) {
      if (this.electiveGroupSubjectIds.includes(value)) {
        this.groupSubjects = []
        this.electiveSubjects = find(this.classSubjects.elective_subjects, {
          elective_subject_id: value,
        }).electives
      } else if (this.groupSubjectIds.includes(value)) {
        this.electiveSubjects = []
        this.groupSubjects = find(this.classSubjects.group_subjects, {
          group_subject_id: value,
        }).group_subjects
      } else {
        this.electiveSubjects = []
        this.groupSubjects = []
      }
    }, */
    handleSubjectSelect(value, rowKey) {
      this.teacherSelectSpinning = true
      this.$http.get(`/api/staff/subject`, {
        params: {
          limit: 10,
          session_id: this.sessionId,
          class_id: this.classId,
          section_id: this.sectionId,
          subject_id: value,
        },
      })
        .then(({ data }) => {
          this.teacherSelectSpinning = false
          this.teachers = data.data
          if (this.isMultiSubject) {
            // subject_teachers[`rowKey`]teacher_id
            // subject_teachers[${count-1}]teacher_id
            const fieldData = {}
            fieldData[`subject_teachers[${rowKey - 1}]teacher_id`] = data.data.staff_id
            const mappedfieldsData = mapValues({ ...fieldData }, function(value) {
              return value !== null ? value : undefined
            })
            this.form.setFieldsValue(mappedfieldsData)
          } else {
            this.form.setFieldsValue({
              teacher_id: data.data.staff_id,
            })
          }
        })
        .catch(error => {
          this.teacherSelectSpinning = false
          this.$neoNotify.error(error)
        })
    },
    checkGroupOrElective() {
      if (this.electiveSubjects.length || this.groupSubjects.length) {
        return true
      }
    },
    onMultiSubjectChange(e) {
      this.isMultiSubject = e.target.checked
      this.multiSubjectCount = 2
      this.electiveSubjects = []
      this.groupSubjects = []
    },
    handleAddMoreSubject() {
      if (this.multiSubjectCount < 6) {
        this.multiSubjectCount = this.multiSubjectCount + 1
      }
    },
    handleRemoveSubject() {
      if (this.multiSubjectCount > 2) {
        this.multiSubjectCount = this.multiSubjectCount - 1
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to update the entry!`,
            onOk: () => {
              const timetableData = this.makeTimetableEntryData(values)
              this.$http
                .patch(`/api/timetable/${this.timetableData.id}`, timetableData)
                .then(({ data }) => {
                  this.$emit('updated')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully updated!',
                    description: `Timetable entry has been updated successfully!`,
                  })
                  this.form.resetFields()
                  this.electiveSubjects = []
                  this.groupSubjects = []
                  this.isMultiSubject = false
                  this.multiSubjectCount = 2
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
              this.electiveSubjects = []
              this.groupSubjects = []
              this.isMultiSubject = false
              this.multiSubjectCount = 2
            },
          })
        }

        this.loading = false
      })
    },
    makeTimetableEntryData(values) {
      values.session_id = this.sessionId
      values.class_id = this.classId
      values.section_id = this.sectionId
      // values.type_value = this.typeValue
      values.position = this.position
      values.day = this.day

      // For normal period
      if (values.type === 0) {
        if (this.electiveSubjects.length) {
          values.group_type = 1
        } else if (this.groupSubjects.length) {
          values.group_type = 2
        } else {
          values.group_type = 0
        }

        if (this.isMultiSubject) {
          values.group_type = 3
        }

        if (this.electiveSubjects.length || this.groupSubjects.length) {
          const subjectTeachers = values.subject_teachers.filter(element => {
            return element !== null
          })
          values.subject_teachers = subjectTeachers

          values.group_subject_id = values.subject_id
          delete values.subject_id
        }
      } else {
        values.group_type = 0
      }

      values.start_time = moment(values.start_time).format('HH:mm:ss')
      values.end_time = moment(values.end_time).format('HH:mm:ss')

      // delete values.all_day

      return values
    },
    handleCancel(e) {
      this.form.resetFields()
      this.electiveSubjects = []
      this.groupSubjects = []
      this.multiSubjectCount = 2
      this.isMultiSubject = false
      this.visible = false
    },
  },
}
</script>
